import { z } from "zod";
import { OperatorEnvironment, PlayerRef, PlayerSessionRef, Product } from "./common.ts";

export const TokenRequest = z
  .object({
    product: Product,
    player_session_ref: PlayerSessionRef,
    player_ref: PlayerRef,
  })
  .strict()
  .meta({ id: "TokenRequest" });
export type TokenRequest = z.infer<typeof TokenRequest>;

export const TokenResponse = z
  .object({
    session_token: z.string(),
    token_type: z.literal("Bearer"),
    expires_in: z.int().positive(),
    product: Product,
  })
  .meta({ id: "TokenResponse" });
export type TokenResponse = z.infer<typeof TokenResponse>;

/** Claims of the session token (ES256 JWT, typ strust-session+jwt). */
export const SessionTokenClaims = z
  .object({
    iss: z.string(),
    aud: z.literal("strust-verify"),
    sub: PlayerSessionRef,
    jti: z.uuid(),
    iat: z.int(),
    exp: z.int(),
    operator_id: z.uuid(),
    env: OperatorEnvironment,
    product: Product,
    player_ref: PlayerRef,
    cid: z.uuid(),
  })
  .meta({ id: "SessionTokenClaims" });
export type SessionTokenClaims = z.infer<typeof SessionTokenClaims>;
